/*
 * @Author: cc
 * @Date: 2019-12-08 19:24:27
 * @LastEditTime : 2019-12-30 21:06:29
 * @LastEditors  : cc
 * @FilePath: \xjmediacloud\app\editingCenter\weixin\preview\wxPreviewRouter.js
 * @Description:
 */
/**
 * Author:陈浩
 *
 * Time:2018-06-05 14:30:31
 *
 */
'use strict';
angular.module('editingCenterWeixinPreviewRouterModule', ['weixinPreviewModule']).config([
    '$stateProvider',
    function($stateProvider) {
        $stateProvider.state('weixinPreview', {
            url: '/weixinpreview?wxmetadataid&wxchannelid&&wxchnldocid&wxplatform&isSendState&isawaitrevise&fromsearch', // isawaitrevise->待修订
            views: {
                '': {
                    templateUrl: './editingCenter/weixin/preview/wxPreview_tpl.html',
                    controller: 'weinxinPreviewCtrl',
                },
            },
        });
    },
]);
